import AccordionItem from '@ui/accordion/AccordionItem';
import RadioGroup from '@ui/radioGroup/RadioGroup';
import RadioGroupItem from '@ui/radioGroup/RadioGroupItem';
import api from '@utils/api';
import { calculateDateforJP } from '@utils/stringUtils';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OrderItem from '../clientService/OrderItem';
const AftercareOrderItem = (props) => {
    const { t } = useTranslation();
    const [orderDetail, setOrderDetail] = useState();
    const [selectedProduct, setSelectedProduct] = useState();
    const onOpen = () => {
        api.getOrderDetail(props.order.orderNumber).then((data) => {
            setOrderDetail(data);
        });
    };
    const renderTitle = (order) => (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row orders-listing__order-detail" },
            React.createElement("div", { className: "col-12 col-lg-8 order-detail__column" },
                React.createElement("h2", null,
                    React.createElement("span", { className: "dt" }, t('orderhistory.ordernumber')),
                    React.createElement("span", { className: "dd" }, order.orderNumber))),
            React.createElement("p", { className: "col-12 col-lg-8 order-detail__column" },
                React.createElement("span", { className: "dt" }, t('label.date')),
                React.createElement("span", { className: "dd" }, calculateDateforJP(order.creationDate))))));
    return (React.createElement(AccordionItem, Object.assign({ title: renderTitle(props.order), isTitleMarkup: true, itemClass: "orders-listing__order", accordionId: props.order.orderNumber }, props, { callbackOnOpen: () => onOpen() }), orderDetail && (React.createElement("div", { className: "items-container items-container--box" },
        React.createElement(RadioGroup, { type: "product", id: 'order' + orderDetail.orderNumber, setSelected: (id) => {
                setSelectedProduct(id);
                props.selectItem(id);
            } }, orderDetail === null || orderDetail === void 0 ? void 0 : orderDetail.items.map((item) => (React.createElement(RadioGroupItem, { key: item.UUID, content: React.createElement("div", { className: "optionbox__item__content" },
                React.createElement(OrderItem, { item: item, hidequantity: true, showprice: true })), id: item, selected: (item === null || item === void 0 ? void 0 : item.UUID) === (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.UUID) }))))))));
};
export default AftercareOrderItem;
